const SocialMedia = {
  FACEBOOK: "https://sr-rs.facebook.com/heliant.health",
  LINKEDIN: "https://www.linkedin.com/company/heliant-health",
  INSTAGRAM: "https://www.instagram.com/heliant.rs/",
};

export default SocialMedia;
